/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetActivityRepliesUnreadStatus200ResponseInner
 */
export interface GetActivityRepliesUnreadStatus200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetActivityRepliesUnreadStatus200ResponseInner
     */
    activityId: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityRepliesUnreadStatus200ResponseInner
     */
    activityReplyId: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetActivityRepliesUnreadStatus200ResponseInner
     */
    isUnread: boolean;
}

/**
 * Check if a given object implements the GetActivityRepliesUnreadStatus200ResponseInner interface.
 */
export function instanceOfGetActivityRepliesUnreadStatus200ResponseInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "activityId" in value;
    isInstance = isInstance && "activityReplyId" in value;
    isInstance = isInstance && "isUnread" in value;

    return isInstance;
}

export function GetActivityRepliesUnreadStatus200ResponseInnerFromJSON(json: any): GetActivityRepliesUnreadStatus200ResponseInner {
    return GetActivityRepliesUnreadStatus200ResponseInnerFromJSONTyped(json, false);
}

export function GetActivityRepliesUnreadStatus200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetActivityRepliesUnreadStatus200ResponseInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activityId': json['activityId'],
        'activityReplyId': json['activityReplyId'],
        'isUnread': json['isUnread'],
    };
}

export function GetActivityRepliesUnreadStatus200ResponseInnerToJSON(value?: GetActivityRepliesUnreadStatus200ResponseInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'activityId': value.activityId,
        'activityReplyId': value.activityReplyId,
        'isUnread': value.isUnread,
    };
}

